import React from 'react';
import { Button } from 'antd';
import { FaBox, FaList, FaShoppingCart, FaPlus, FaImages } from 'react-icons/fa';
import styles from './QuickActionsRow.module.scss';

interface QuickActionsRowProps {
  productsCount: number;
  categoriesCount: number;
  ordersCount: number;
  galleryCount: number;
}

const QuickActionsRow: React.FC<QuickActionsRowProps> = ({ productsCount, categoriesCount, ordersCount, galleryCount }) => {
  return (
    <div className={styles.quickActionsRow}>
      <div className={styles.actionCard}>
        <div className={styles.leftContent}>
          <div className={styles.count}>{productsCount}</div>
          <div className={styles.label}>proizvoda</div>
        </div>
        <div className={styles.iconRight}><FaBox /></div>
        <Button type="default" className={styles.addButton} href="/admin/products/create">
          Dodaj novi proizvod
        </Button>
      </div>
      <div className={styles.actionCard}>
        <div className={styles.leftContent}>
          <div className={styles.count}>{categoriesCount}</div>
          <div className={styles.label}>kategorija</div>
        </div>
        <div className={styles.iconRight}><FaList /></div>
        <Button type="default" className={styles.addButton} href="/admin/categories/create">
          Dodaj novu kategoriju
        </Button>
      </div>
      <div className={styles.actionCard}>
        <div className={styles.leftContent}>
          <div className={styles.count}>{ordersCount}</div>
          <div className={styles.label}>narudžbina</div>
        </div>
        <div className={styles.iconRight}><FaShoppingCart /></div>
        <Button type="default" className={styles.addButton} href="/admin/orders/create">
          Dodaj novu narudžbinu
        </Button>
      </div>
      <div className={styles.actionCard}>
        <div className={styles.leftContent}>
          <div className={styles.count}>{galleryCount}</div>
          <div className={styles.label}>galerija</div>
        </div>
        <div className={styles.iconRight}><FaImages /></div>
        <Button type="default" className={styles.addButton} href="/admin/media">
          Uredite galeriju
        </Button>
      </div>
    </div>
  );
};

export default QuickActionsRow; 